export default __webpack_public_path__ + "static/media/single-project-page-05-img-01.af572ed9.jpg";